/**
 * Join-host layout components
 *
 * Kept in their own file (rather than inline in routes.tsx) so the router
 * module can keep exporting plain route config without upsetting fast
 * refresh, which only works cleanly when a file exports just components.
 */

import { Suspense } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

/**
 * Bare Suspense boundary for the join host — no header, no marketing
 * chrome, no dashboard sidebar. Students only ever see the code-entry
 * screen or the model itself.
 */
export function JoinLayout() {
  return (
    <div className="flex h-dvh min-h-0 flex-col overflow-hidden">
      <Suspense
        fallback={
          <div className="flex min-h-0 flex-1 items-center justify-center bg-gradient-to-b from-primary to-blue-600">
            <Loader2 className="h-8 w-8 animate-spin text-white" />
          </div>
        }
      >
        <div className="min-h-0 flex-1">
          <Outlet />
        </div>
      </Suspense>
    </div>
  );
}

/** Bare `join.scimodeling.com/CODE` deep link → the shared model route. */
export function CodeRedirect() {
  const { code } = useParams<{ code: string }>();
  return <Navigate to={`/share/${code ?? ''}`} replace />;
}
